/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'kepler/lib/components/Button';
import classNames from 'classnames';

/**
 * Re-usable Component for omni channel prompt card
 */
const OmniChannelPromptComponent = (props) => {
  const {
    intentDescription, confirmLabel, rejectLabel, omniChannelApproveIntentCBFunc, omniChannelRejectIntentCBFunc, entryPoint,
  } = props;

  const getWidgetClassName = () => classNames({
    'omnichannel-prompt': true,
    'minihelp-omnichannel-prompt': entryPoint === 'minihelp',
  });

  return (
    <div className={getWidgetClassName()}>
      <div className="omnichannel-prompt__intent-description">
        {intentDescription}
      </div>
      <div className="omnichannel-prompt__confirm-btns">
        <Button
          className="omnichannel-prompt__confirm-btns--yesbtn"
          size="sm"
          type="primary"
          onClick={() => omniChannelApproveIntentCBFunc()}
        >
          {confirmLabel}
        </Button>
        <Button
          className="omnichannel-prompt__confirm-btns--nobtn"
          size="sm"
          type="secondary"
          onClick={() => omniChannelRejectIntentCBFunc()}
        >
          {rejectLabel}
        </Button>
      </div>
    </div>
  );
};

OmniChannelPromptComponent.propTypes = {
  intentDescription: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  rejectLabel: PropTypes.string.isRequired,
  omniChannelRejectIntentCBFunc: PropTypes.func.isRequired,
  omniChannelApproveIntentCBFunc: PropTypes.func.isRequired,
  entryPoint: PropTypes.string,
};

export default OmniChannelPromptComponent;
